import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table table-sm table-hover table-borderless"
}

import { format_date } from '@/helpers/filters'
import { EVENT_NAME__ACCOUNT_NOTIFICATIONS_READ } from '@/api/AccountNotificationsApi'
import { onBeforeMount, reactive, ref } from 'vue'
import { AccountNotification, ListResponse } from '@/types/api'
import { accountNotificationsApi } from '@/di/api'
import eventBus from '@/di/eventBus'
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountNotificationsList',
  setup(__props) {

const lock = reactive<{ loading: boolean }>({ loading: false })

const accountNotifications = ref<ListResponse<AccountNotification>>({ items: [], total_count: 0 })

async function loadList (): Promise<void> {
  accountNotifications.value = await accountNotificationsApi.getList()
}

onBeforeMount(async (): Promise<void> => {
  try {
    lock.loading = true
    await loadList()
  } finally {
    lock.loading = false
  }

  setTimeout(
      async (): Promise<void> => {
        const ids = accountNotifications.value.items
            .filter(({ is_unread }) => is_unread)
            .map(({ id }) => id)

        if (ids.length === 0) return

        eventBus.$once(EVENT_NAME__ACCOUNT_NOTIFICATIONS_READ, loadList)
        await accountNotificationsApi.read(ids)
      },
      1000
  )
})

return (_ctx: any,_cache: any) => {
  return (lock.loading)
    ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 0 }, {
        default: _withCtx(() => [
          _createTextVNode("Loading account notifications list")
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountNotifications.value.items, (accountNotification) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: accountNotification.id,
              class: _normalizeClass({'fw-bold': accountNotification.is_unread})
            }, [
              _createElementVNode("td", null, _toDisplayString(accountNotification.title), 1),
              _createElementVNode("td", null, _toDisplayString(accountNotification.body), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(format_date)(accountNotification.created_at, 'date_time')), 1)
            ], 2))
          }), 128))
        ])
      ]))
}
}

})